import React from 'react';
import {EditRightPanelTab} from '../../../../../components/layout/page-layout/layout-typings';
import {useDocumentSidebarState} from './use-document-sidebar-state';

interface Props {
    isExploreView: boolean;
    docInfo?: EditModeDoc | ViewModeDoc;
    docSidebarState: ReturnType<typeof useDocumentSidebarState>;
}

export function useHasOntologyTree({
    isExploreView,
    docInfo,
    docSidebarState: {isSidebarOpen, selectedTab, closeSidebar}
}: Props) {
    const hasOntologyTree =
        !isExploreView &&
        ['ONTOLOGY', 'PROCESSES', 'OBJECT_PROPERTIES', 'NOTIONS'].includes(docInfo?.type || '');

    React.useEffect(() => {
        if (
            isSidebarOpen &&
            !hasOntologyTree &&
            selectedTab === EditRightPanelTab.HIERARCHICAL_TREE
        ) {
            closeSidebar();
        }
    }, [isSidebarOpen, closeSidebar, hasOntologyTree, selectedTab]);

    return {hasOntologyTree};
}
